import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Box,
    useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';


interface ConfirmationAlertProps {
    onDelete: () => void;
    message: string;
    open: boolean;
    handleClose: () => void;
    yesLabel?: string;
    noLabel?: string;
}

const ConfirmationAlert: React.FC<ConfirmationAlertProps> = ({
    onDelete,
    message,
    open,
    handleClose,
    yesLabel,
    noLabel,
}) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const handleDelete = () => {
        onDelete();
        handleClose();
    };
    

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{ sx: { display: 'inline-block', minWidth: 0, maxWidth: '420px' } }}
        >
            <DialogContent sx={{ display: 'flex', justifyContent: 'center', px: { xs: 1, sm: 2 }, pt: 2, pb: { xs: 1, sm: 1.5 } }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                    <DialogContentText
                        id="alert-dialog-description"
                        sx={{
                                color: 'rgba(0, 0, 0, 0.87)',
                                whiteSpace: 'normal',
                                wordBreak: 'break-word',
                                maxWidth: '100%',
                                overflowWrap: 'break-word',
                            }}
                    >
                        {message}
                    </DialogContentText>

                    <DialogActions sx={{ gap: 0.5, justifyContent: 'flex-end', mt: 1, mb: 0, mr: 1, width: '100%' }}>
                        <Button sx={{
                            borderRadius: '6px',
                            width: 'auto',
                            padding: "8px 8px",
                            backgroundColor: 'error.dark',
                            color: theme.palette.secondary.main,
                            fontWeight: 700,
                            textTransform: 'none',
                        }}
                        onClick={handleClose}>{noLabel || t('modal.no')}</Button>
                        <Button sx={{
                            borderRadius: '6px',
                            width: 'auto',
                            padding: "8px 8px",
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.secondary.main,
                            fontWeight: 700,
                            textTransform: 'none',
                        }}
                        onClick={handleDelete}>
                            {yesLabel || t('modal.yes')}
                        </Button>
                    </DialogActions>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default ConfirmationAlert;
